import React from "react";
import { Box, Typography } from "@mui/material";
import { brand, gray } from "../../../../../theme/themePrimitives";

interface VersionChipProps {
  version: string | null | undefined;
  isLatest?: boolean;
}

export const VersionChip: React.FC<VersionChipProps> = ({
  version,
  isLatest = false,
}) => {
  if (!version) {
    return (
      <Typography fontSize={13} color="#475467">
        -
      </Typography>
    );
  }

  const color = isLatest ? brand[600] : gray[700];
  const borderColor = isLatest ? brand[200] : gray[300];
  const backgroundColor = `${color}1A`;

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        px: 1.25,
        py: 0.4,
        borderRadius: "16px",
        backgroundColor,
        border: `1px solid ${borderColor}`,
        whiteSpace: "nowrap",
      }}
    >
      <Typography fontSize={12} fontWeight={500} color={color} lineHeight={1}>
        {version}
      </Typography>
    </Box>
  );
};
